import React from 'react';
import { useTranslation } from 'react-i18next';
import { memberCashLimitsType } from '../../types';
import MemberCashLimitRow from './MemberCashLimitRow';
import './_styles_/MemberCashLimitsTable.css';

MemberCashLimitsTable.propTypes = {
    cashLimits: memberCashLimitsType.isRequired,
};

function MemberCashLimitsTable(props) {
    const {
        cashLimits,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="member-detail-tab--cash-limits">
            <div className="field">
                <span className="field--key">{t('members.cash-limits.title')}</span>
                <div className="detail-list">
                    <div className="detail-list-row detail-list-header">
                        <div className="cash-limit-cell">{t('members.cash-limits.clearing-house')}</div>
                        <div className="cash-limit-cell">{t('members.cash-limits.clearing-house-time-zone')}</div>
                        <div className="cash-limit-cell">{t('members.cash-limits.currency')}</div>
                        <div className="cash-limit-cell">{t('members.cash-limits.initial-cash-limit')}</div>
                        <div className="cash-limit-cell">{t('members.cash-limits.current-cash-limit')}</div>
                        <div className="cash-limit-cell">{t('members.cash-limits.current-auction-day')}</div>
                        <div className="cash-limit-cell">{t('members.cash-limits.next-auction-day-initial-cash-limit')}</div>
                        <div className="cash-limit-cell">{t('members.cash-limits.next-auction-day')}</div>
                    </div>
                    {cashLimits.map((cashLimit) => <MemberCashLimitRow key={`${cashLimit.clearingHouse.code}-${cashLimit.currency.code}`} cashLimit={cashLimit} />)}
                </div>
            </div>
        </div>
    );
}

export default MemberCashLimitsTable;
